





































import Vue from 'vue'
import SectionBase from '@/mixins/SectionBase'
import ServiceSectionBase from './ServiceSectionBase'
import * as moment from 'moment';

export default Vue.extend({
  mixins: [SectionBase, ServiceSectionBase],
  data () {
    return {
      showOrderNoInfo: false,
    }
  },
  computed: {
    currentYear(): number {
      return moment().year();
    }
  }
})
